import OrderModal from './OrderModal.view';

export default OrderModal;
